import { ActiveAdminInfo } from "@sgm-frontend/core";


export interface AdminLoginResponse {
  token: string;
  user: ActiveAdminInfo;
}
export interface CustomerLoginResponseDetail {
  data: {
    accessToken: string,
    refreshToken: string,
    profile: ProfileInfo,
    language:string
  }

}

export interface CustomerLoginResponse {
  accessToken: string,
  refreshToken: string,
  profile?: ProfileInfo,
  language?:string
}
export interface ProfileInfo {
  id: string,
  username: string,
  email: string,
  is_email_verified: Boolean,
  full_name: string,
  phone: string,
  is_phone_verified: Boolean,
  language: string,
  is_guest: Boolean,
  is_deleted: Boolean,
  is_suspended: Boolean,
  is_staff: Boolean,
  cached_user_role: Boolean,
  createdAt: Date,
  updatedAt: Date,
  user_roles: []

}
export interface CustomerrefreshResponse {
  accessToken: string;
}
export interface CustomerAccessInput {
  refreshToken: string;
}
